import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import SelfReadingDTO from 'features/contracts/dtos/SelfReadingDTO';
import RoundButton from 'features/shared/components/buttons/RoundButton';
import DateFormatter from 'features/shared/components/formatters/DateFormatter';
import React from 'react';
import { useTranslation } from 'react-i18next';
import SelfReadingStatusLabel from './SelfReadingStatus';
import SelfReadingMeter from './SelfReadingMeter';
import { useLocation } from 'react-router-dom';
import { ContractType } from 'features/contracts/enums/contractType';
import EnergyUnit from 'features/contracts/components/EnergyUnit';

interface Props {
  selfReading: SelfReadingDTO;
  contractType: ContractType;
}

const SelfReading = ({ selfReading, contractType }: Props) => {
  const { t } = useTranslation(["contracts\\enums\\selfReadingType"]);
  const location = useLocation();

  // render
  return (
    <div className="row no-gutters align-items-center">
      <div className="col">
        <div className="row no-gutters align-items-center">
          <div className="col-sm-6 col-lg-6">
            <div className="row no-gutters align-items-center">
              <div className="col-auto col-sm-auto col-lg-5 pr-2 pr-sm-4 pr-lg-0">
                <div className="d-flex flex-wrap flex-sm-column">
                  <span className="mr-2 mr-lg-0">
                    <span className="mr-1 text-muted">
                      <FontAwesomeIcon icon="calendar-alt" size="xs" fixedWidth />
                    </span>
                    <span className="small">
                      <DateFormatter date={selfReading.createdDate!} />
                    </span>
                  </span>
                  <span className="mt-lg-n1">
                    <span className="mr-1 text-muted">
                      <FontAwesomeIcon icon="calendar-check" size="xs" fixedWidth />
                    </span>
                    <span className="small">
                      <DateFormatter date={selfReading.readingDate!} />
                    </span>
                  </span>
                </div>
              </div>
              <div className="col-auto col-sm col-lg-7">
                <div className="text-truncate" title={t(selfReading.selfReadingType || "")}>
                  <span className="d-sm-none mr-1 text-muted">
                    <FontAwesomeIcon icon="ticket-alt" size="xs" fixedWidth />
                  </span>
                  {t(selfReading.selfReadingType || "")}
                </div>
              </div>
            </div>
          </div>
          <div className="col-sm-6">
            <div className="row no-gutters align-items-center">
              <div className="col-auto col-sm-6 pl-sm-3 pl-lg-4">
                <SelfReadingMeter 
                  value={selfReading.value} 
                  valueNT={selfReading.valueNT} 
                  renderUnit={() => <EnergyUnit contractType={contractType} />}
                />
              </div>  
              <div className="col col-sm-6 pl-2 pl-sm-0">
                <div className="d-flex">
                  <SelfReadingStatusLabel status={selfReading.selfReadingStatus!} />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="col-auto pl-2 pl-sm-3">
        <RoundButton asLink to={`self-readings/${selfReading.selfReadingId}`} />
      </div>
    </div>
  )
}

export default SelfReading;
